import { clientFetch } from '../clientFetch';

/*
 * Ads
 */
export const getAds = (page, params) => {
  return clientFetch(`/ribbon/${page}`, { params });
};

export const getCampaigns = (params) => {
  return clientFetch(`/campaigns`, { params });
};
